import React from "react";
import { Link } from "react-router-dom";
import { UserPlus, Sparkles } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { FollowSuggestions } from "@/components/FollowSuggestions";

// Lot 609 — mode d'affichage du fil « abonnements » actif côté système, mais le membre suit encore trop peu de comptes
// (< min_follows) : il voit tout le monde en attendant + cette carte qui l'invite à suivre des membres.
export const FeedModeNudgeCard = ({ scope }) => {
  const { t } = useApp();
  if (!scope?.fallback) return null;
  const left = Math.max(0, (scope.min_follows || 0) - (scope.follow_count || 0));
  return (
    <div className="yalola-card p-4" data-testid="feed-mode-nudge" data-left={left}>
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-xl grid place-items-center shrink-0" style={{ background: "var(--yalola-surface-alt)", color: "var(--yalola-primary)" }}><Sparkles size={18} /></div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm" data-testid="feed-mode-nudge-title">{t("feed.mode_nudge_title", "Suis des membres pour personnaliser ton fil")}</div>
          <p className="text-xs mt-0.5" style={{ color: "var(--yalola-text-muted)" }} data-testid="feed-mode-nudge-desc">
            {t("feed.mode_nudge_desc", "Ton fil affichera bientôt surtout les publications des comptes que tu suis. Encore {n} à suivre pour l'activer.").replace("{n}", String(left))}
          </p>
          <Link to="/matching" className="pill pill-outline !text-[12px] !px-3 !py-1 inline-flex items-center gap-1 mt-2" data-testid="feed-mode-nudge-cta"><UserPlus size={13} /> {t("feed.mode_nudge_cta", "Trouver des membres")}</Link>
        </div>
      </div>
      <FollowSuggestions variant="feed" />
    </div>
  );
};

export default FeedModeNudgeCard;
